import { useLocation } from "react-router";

/** "/admin" inside the admin dashboard, "" in the owner app. Shared pages build links with it. */
export function useShellPrefix(): "" | "/admin" {
  return useLocation().pathname.startsWith("/admin") ? "/admin" : "";
}
